var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emojione-monotone:clipboard",
    filter: "url(#filter0_dd_984_15587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M30.1378 6.93069L24.7559 4.55859L5.02246 33.0237L27.7458 48.4423L49.8712 15.826L42.6954 12.2679V10.4888L40.9015 9.30278V7.52371L35.5196 5.15162L33.7257 5.74464L31.3337 5.15162L30.1378 6.93069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.543 12.9817L43.5888 10.3807L43.5848 10.3624C43.3807 9.67704 42.8608 9.10727 42.1585 8.79888L41.9319 8.69848C41.9934 8.35424 41.9725 8.00048 41.8708 7.66573C41.6659 6.98838 41.1484 6.42818 40.4518 6.12855L36.6679 4.50054C36.3175 4.35134 35.9403 4.27434 35.559 4.27423C34.8117 4.27423 34.1231 4.55632 33.6377 5.04719L33.2143 4.86073C32.8652 4.7078 32.4878 4.62908 32.1062 4.62963C31.706 4.62963 31.33 4.72446 30.9868 4.87746L26.4549 2.89723C24.8743 2.20873 22.9 2.74024 22.0169 4.07501L4.10682 31.2094C3.22534 32.5442 3.62228 34.4033 5.01482 35.3755L25.3765 49.5933C27.1789 50.8524 29.5003 50.6308 30.5296 49.0737L51.4145 17.4322C52.443 15.8751 51.588 13.875 49.543 12.9817ZM29.7872 8.67935L31.1725 6.58118C31.3645 6.28952 31.7301 6.12377 32.107 6.12377C32.2749 6.12377 32.4453 6.15644 32.6036 6.22657L34.1552 6.90869L34.6028 6.23135C34.798 5.9373 35.1725 5.76837 35.5598 5.76837C35.7318 5.76837 35.9069 5.80104 36.0692 5.87116L39.8531 7.49998C40.4059 7.73744 40.6213 8.28888 40.3336 8.72876L39.8724 9.42602L41.5494 10.1647C42.1143 10.4126 42.3369 10.9767 42.0436 11.4238L40.5763 13.6439C40.3802 13.9419 40.0066 14.1077 39.6129 14.1077C39.4168 14.1077 39.2159 14.0654 39.0287 13.9802L30.201 9.86829C29.6923 9.63162 29.5075 9.1009 29.7872 8.67935ZM27.2882 47.2338L6.30129 33.004L24.761 5.04002L29.0937 7.00193L28.5272 7.86096C28.3479 8.12994 28.229 8.43406 28.1786 8.75264C28.1283 9.07123 28.1477 9.39683 28.2355 9.70732C28.4219 10.3631 28.9049 10.9146 29.5598 11.2198L38.3867 15.3317C38.7701 15.5092 39.1881 15.6011 39.6112 15.601C40.5337 15.601 41.3662 15.1747 41.8363 14.4599L42.6944 13.1602L48.1497 15.6305L27.2882 47.2338Z",
    fill: "url(#paint0_linear_984_15587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.8388 15.9181C27.6547 16.1973 27.7545 16.5746 28.0526 16.7262L38.8309 22.2078C39.0998 22.3445 39.4286 22.2575 39.5947 22.0056C39.7901 21.7092 39.683 21.3086 39.3656 21.1493L28.5581 15.7257C28.3042 15.5983 27.9952 15.681 27.8388 15.9181ZM23.45 15.7167C23.4974 15.849 23.6397 15.8992 23.7706 15.8259L26.9687 14.048C26.999 14.0324 27.0253 14.0101 27.0455 13.9828C27.0658 13.9556 27.0795 13.9241 27.0855 13.8908C27.0916 13.8574 27.0898 13.8232 27.0804 13.7906C27.0711 13.7581 27.0543 13.7281 27.0314 13.703L26.8562 13.4958C26.8056 13.439 26.7373 13.4006 26.6621 13.3869C26.5869 13.3732 26.5093 13.3849 26.4416 13.4201L24.2528 14.6425C24.1242 14.7158 23.9796 14.6672 23.9346 14.5341L23.5497 13.4233C23.5039 13.2934 23.344 13.2129 23.1929 13.244L22.9157 13.3006C22.7654 13.3308 22.677 13.4639 22.7228 13.5938L23.45 15.7167ZM24.2013 21.4275C24.0199 21.702 24.1116 22.0728 24.3998 22.2312L34.9597 28.0351C35.2313 28.1844 35.572 28.1003 35.7429 27.8417C35.9354 27.5505 35.8371 27.1569 35.5303 26.9904L24.9395 21.243C24.6828 21.1037 24.3622 21.1838 24.2013 21.4275ZM22.9424 20.1985C23.3269 19.6155 23.1271 18.8281 22.511 18.4991L21.1563 17.7757C20.616 17.4872 19.945 17.6575 19.6077 18.1687L18.9353 19.1876C18.5552 19.7636 18.7452 20.5413 19.3482 20.877L20.688 21.6233C21.2302 21.9252 21.9135 21.7582 22.2552 21.2402L22.9424 20.1985ZM20.5632 26.9389C20.3863 27.2076 20.4698 27.5695 20.7466 27.7335L31.0886 33.8604C31.3629 34.023 31.7165 33.9413 31.8917 33.6749C32.0797 33.3891 31.9896 33.0041 31.6943 32.8314L21.3181 26.7625C21.0596 26.6113 20.7279 26.6888 20.5632 26.9389ZM19.3692 25.6134C19.7455 25.0432 19.5636 24.2739 18.9719 23.9326L17.643 23.1661C17.0995 22.8527 16.4058 23.0167 16.0603 23.5405L15.3852 24.5641C15.0138 25.1271 15.1861 25.886 15.7641 26.2336L17.0772 27.0232C17.622 27.3508 18.3281 27.1906 18.6783 26.6601L19.3692 25.6134ZM16.9268 32.4485C16.7533 32.7114 16.8288 33.0654 17.0944 33.2346L27.2209 39.6845C27.4958 39.8596 27.8602 39.7821 28.04 39.5103C28.225 39.2307 28.1437 38.8536 27.8599 38.6751L17.6976 32.2818C17.4381 32.1186 17.0956 32.1926 16.9268 32.4485ZM11.8367 29.9406C11.4733 30.491 11.6288 31.2323 12.1828 31.5902L13.4671 32.42C14.0135 32.7731 14.7423 32.6201 15.1006 32.0772L15.7928 31.0285C16.1609 30.4708 15.9959 29.7194 15.428 29.3672L14.1284 28.5611C13.5828 28.2228 12.8671 28.3799 12.5135 28.9156L11.8367 29.9406Z",
    fill: "url(#paint1_linear_984_15587)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_984_15587",
    x: -1.52591,
    y: -1.37209,
    width: 58.543,
    height: 58.1163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.18605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.77907
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_984_15587"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.18605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.18605
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_984_15587",
    result: "effect2_dropShadow_984_15587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_984_15587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_984_15587",
    x1: 27.7448,
    y1: 2.5957,
    x2: 27.7448,
    y2: 72.1194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#1B1B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#1E334F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#267895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#267895"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_984_15587",
    x1: 25.5694,
    y1: 13.2373,
    x2: 25.5694,
    y2: 52.1528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#1B1B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#1E334F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#267895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#267895"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIconBlue);
export default __webpack_public_path__ + "static/media/checklist-icon-blue.711ee79da705fd5ef1cfb543a7fb86a6.svg";
export { ForwardRef as ReactComponent };